import debounce from 'lodash.debounce';
import countdownTimer from '../../components/countdownTimer/countdownTimer';

const notificationBannerInit = () => {
    const notificationBanners = document.querySelectorAll('.s-notification-banner');
    notificationBanners.forEach(notificationBanner => {
        /**
         * @type {HTMLElement}
         */
        const countdownEl = notificationBanner.querySelector('[data-countdown-timer]');
        if (countdownEl) {
            try {
                const { countdownTimer: endDateString } = countdownEl.dataset;
                const spanSr = document.createElement('span');
                const spanSrText = document.createTextNode('Time remaining:');
                const spanTimer = document.createElement('span');
                const para = document.createElement('p');
                spanSr.classList.add('sr-only');
                spanSr.appendChild(spanSrText);
                spanTimer.classList.add('banner-countdown-text');
                para.appendChild(spanSr);
                para.appendChild(spanTimer);
                countdownEl.appendChild(para);
                const runCb = (dd, hh, mm, ss) => {
                    const toStringWithZero = num =>
                        `${num < 10 ? '0' : ''}${num}`;
                    const day = toStringWithZero(dd);
                    const hour = toStringWithZero(hh);
                    const minute = toStringWithZero(mm);
                    const second = toStringWithZero(ss);
                    const timerString = `${
                        day > 0 ? `${day}:` : ''
                    }${hour}:${minute}:${second}`;
                    spanTimer.textContent = timerString;
                };
                runCb(0, 0, 0, 0);
                countdownTimer(endDateString, runCb);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
        /**
         * @type {HTMLElement}
         */
        const bannerMarquee =
            notificationBanner.querySelector('.banner-marquee');
        const bannerMarqueeP = bannerMarquee.querySelector('p');

        const createMarqueeKeyframes = () => [
            { transform: `translateX(${bannerMarquee.clientWidth}px)` },
            { transform: 'translateX(-100%)' }
        ];
        const createMarqueeTiming = () => {
            return {
                duration:
                    (bannerMarquee.clientWidth + bannerMarqueeP.clientWidth) /
                    0.08,
                iterations: Infinity
            };
        };
        let marqueeAnimation = bannerMarqueeP.animate(
            createMarqueeKeyframes(),
            createMarqueeTiming()
        );

        marqueeAnimation.onfinish = () => {
            marqueeAnimation.cancel();
            marqueeAnimation.updatePlaybackRate(0);
        };

        const buttonLeft = notificationBanner.querySelector('.left-btn');
        const buttonRight = notificationBanner.querySelector('.right-btn');

        bannerMarquee.addEventListener('mouseenter', () => {
            marqueeAnimation.pause();
            bannerMarquee.addEventListener('mouseleave', () => {
                marqueeAnimation.play();
            }, { once: true });
        });

        buttonLeft.addEventListener('click', () => {
            marqueeAnimation.updatePlaybackRate(1);
            marqueeAnimation.play();
        });

        buttonRight.addEventListener('click', () => {
            marqueeAnimation.updatePlaybackRate(-1);
        });

        const resizeDebouncer = debounce(() => {
            marqueeAnimation.cancel();
            marqueeAnimation = bannerMarqueeP.animate(
                createMarqueeKeyframes(),
                createMarqueeTiming()
            );
        }, 500);

        const marqueeResizeObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                if (entry.contentBoxSize) {
                    resizeDebouncer();
                }
            });
        });

        marqueeResizeObserver.observe(bannerMarquee);
    });
};

document.addEventListener('DOMContentLoaded', notificationBannerInit);
